import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Row, Col} from 'react-bootstrap'
import moment from 'moment'
import '../components/css/IdeaOwner.css'
import '../components/css/NotificationListItem.css'

let notifRowStyle = {
    backgroundColor: '#ffffff',
    color: '#000000',
    display: 'block',
}

class NotificationListItem extends Component {
    render() {
        let ago = moment(this.props.item.timestamp).fromNow()
        return (
            <Row style={notifRowStyle}>
                <Col className='notificationOwner' sm={3} xs={3}>
                    <img className='ideaOwnerImage' style={{display: 'block', margin: 'auto'}} alt={this.props.item.title} src={this.props.item.icon}/>
                </Col>
                <Col className='notificationText' sm={9} xs={9}>
                    <b>
                        {this.props.item.title}
                    </b>
                    <div>
                        {this.props.item.body}
                    </div>
                    <i>
                        {ago}
                    </i>
                </Col>             
            </Row> 
        )
    }
}
NotificationListItem.propTypes = {
    item: PropTypes.object.isRequired,
}

export default NotificationListItem



// WEBPACK FOOTER //
// ./src/components/NotificationListItem.js